var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr14 pl14"},[_c('collect-list-component',{attrs:{"collect-type":'userCollect',"default-filter":{uuid:_vm.memberKey}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }